module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product23-240d201c041fa392a9f8f916b63bbef9.jpg";